import React from 'react';
import { Outlet } from 'react-router-dom';

interface NotasFiscaisRootPageInterface {}

const NotasFiscaisRootPage: React.FC<NotasFiscaisRootPageInterface> = () => <Outlet />;

export default NotasFiscaisRootPage;
